import React from 'react';
import { Plus, Tag } from 'lucide-react';
import { questionTemplates } from '../data/questionTemplates';
import { cn } from '../utils/cn';
import type { Question, QuestionTemplate } from '../types';

interface QuestionTemplateSelectorProps {
  onSelect: (template: QuestionTemplate) => void;
}

export function QuestionTemplateSelector({ onSelect }: QuestionTemplateSelectorProps) {
  const categories = Array.from(new Set(questionTemplates.map(t => t.category)));

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium text-gray-900">
          Modelos de Questão
        </h3>
        <span className="text-sm text-gray-500">
          Clique para usar um modelo
        </span>
      </div>

      {categories.map(category => (
        <div key={category} className="space-y-2">
          <div className="flex items-center gap-2 text-sm font-medium text-gray-700">
            <Tag className="h-4 w-4" />
            {category}
          </div>

          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            {questionTemplates
              .filter(t => t.category === category)
              .map(template => (
                <button
                  key={template.id}
                  onClick={() => onSelect(template)}
                  className={cn(
                    "flex items-start gap-3 rounded-lg border p-3 text-left",
                    "transition-colors hover:bg-gray-50 active:bg-gray-100"
                  )}
                >
                  <Plus className="h-5 w-5 flex-shrink-0 text-gray-400" />
                  <div className="flex-1 space-y-1">
                    <p className="text-sm font-medium text-gray-900 line-clamp-2">
                      {template.text}
                    </p>
                    <div className="flex items-center gap-2">
                      <span className={cn(
                        "inline-flex items-center rounded-full px-2 py-1 text-xs font-medium",
                        template.type === 'single' 
                          ? "bg-blue-100 text-blue-700"
                          : "bg-purple-100 text-purple-700"
                      )}>
                        {template.type === 'single' ? 'Única Escolha' : 'Múltipla Escolha'}
                      </span>
                      <span className={cn(
                        "inline-flex items-center rounded-full px-2 py-1 text-xs font-medium",
                        template.difficulty === 'easy' 
                          ? "bg-green-100 text-green-700"
                          : template.difficulty === 'medium'
                            ? "bg-yellow-100 text-yellow-700"
                            : "bg-red-100 text-red-700"
                      )}>
                        {template.difficulty === 'easy' ? 'Fácil' : template.difficulty === 'medium' ? 'Médio' : 'Difícil'}
                      </span>
                    </div>
                  </div>
                </button>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
}